import React, { useEffect, useState } from 'react';
import TopAddress from '../components/TopAddress';
import { callGetWebservice, callPostWebservice } from '../hooks/api';
import { useDispatch } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import StaticPageHeader from '../components/common/StaticPageHeader';

const MyAddresses = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [addresses, setAddresses] = useState([]);

    const fetchAddress = () => {
        callGetWebservice('addresses', {}, (response) => {
            setAddresses(response.data);
        }, null, dispatch, navigate);
    }
    useEffect(() => {
        fetchAddress();
    }, []);

    const btnEditClick = (index) => {
        const selectedAddress = addresses[index];
        navigate("/addaddress", { state: { address: selectedAddress } });
    }

    const btnDeleteClick = (id) => {

        const confirmDelete = window.confirm("Are you sure you want to delete this address?");

        if (confirmDelete) {

            callPostWebservice('delete-address', {
                id: id
            }, (response) => {
                fetchAddress();
            });
        }
    }

    return (
        <div className="static-page-wrapper bg-light min-vh-100 pb-5">
            <StaticPageHeader title="Saved Addresses" />

            <div className="container static-page-container mt-4">
                <div className="row align-items-start mt-1">
                    <TopAddress />
                    <div className="col-12 col-md-8">
                        <div className="bg-white border shadow-sm p-4 p-md-5 mb-4" style={{ borderRadius: '12px' }}>
                            <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                                <div>
                                    <h3 className="fw-bold text-dark mb-1" style={{ fontSize: '1.75rem' }}>Saved Addresses</h3>
                                    <p className="text-secondary mb-0">Manage your shipping and billing addresses</p>
                                </div>
                            </div>
                            
                            <div className="row g-4">
                                {addresses.map((address, index) => (
                                    <div key={index} className="col-12 col-md-6 mb-4">
                                        <div className="p-4 position-relative bg-white transition-hover h-100 d-flex flex-column" style={{ border: address.is_default_address === 1 ? '1px solid #111827' : '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                                            
                                            <div className="d-flex justify-content-between align-items-start mb-4">
                                                <div className="d-flex align-items-center">
                                                    <div className="d-inline-flex align-items-center justify-content-center bg-light text-dark mr-3" style={{ width: '42px', height: '42px', borderRadius: '50%' }}>
                                                        <i className={address.type?.toLowerCase() === 'home' ? 'fas fa-home' : 'fas fa-building'}></i>
                                                    </div>
                                                    <div>
                                                        <h6 className="fw-semibold text-dark mb-1" style={{ fontSize: '1rem' }}>{address.name}</h6>
                                                        <span className="text-secondary small fw-medium text-capitalize">{address.type || 'Address'}</span>
                                                    </div>
                                                </div>
                                                {address.is_default_address === 1 && (
                                                    <span className="badge bg-light text-dark border px-2 py-1" style={{ fontSize: '0.7rem', letterSpacing: '0.3px', borderRadius: '6px' }}>DEFAULT</span>
                                                )}
                                            </div>

                                            <div className="flex-grow-1 mt-1 mb-4">
                                                <p className="text-secondary mb-1" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                                                    {address.address}
                                                </p>
                                                <p className="text-secondary mb-3" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                                                    {address.city?.name}, {address?.area?.name} {address.zip_code}<br />
                                                    {address?.city?.state?.country?.name}
                                                </p>
                                                <div className="text-dark fw-medium d-flex align-items-center" style={{ fontSize: '0.9rem' }}>
                                                    <i className="fas fa-phone-alt mr-2 text-muted"></i>
                                                    <span>{address.phone_number}</span>
                                                </div>
                                            </div>

                                            <div className="d-flex gap-2 border-top pt-3 mt-auto">
                                                <button onClick={() => btnEditClick(index)} className="btn btn-light bg-white border flex-fill py-2 fw-medium transition-hover" style={{ borderRadius: '8px', fontSize: '0.85rem', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
                                                    Edit
                                                </button>
                                                <button onClick={() => btnDeleteClick(address.id)} className="btn btn-light bg-white border text-danger flex-fill py-2 fw-medium transition-hover" style={{ borderRadius: '8px', fontSize: '0.85rem', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {/* Add New Address Card */}
                                <div className="col-12 col-md-6 mb-4">
                                    <NavLink to='/addaddress' className="text-decoration-none h-100 d-block">
                                        <div className="d-flex flex-column align-items-center justify-content-center h-100 transition-hover p-4 bg-white" style={{ borderRadius: '12px', border: '1px dashed #d1d5db', minHeight: '260px' }}>
                                            <div className="rounded-circle border d-flex align-items-center justify-content-center mb-3" style={{ width: '48px', height: '48px', backgroundColor: '#f9fafb' }}>
                                                <i className="fas fa-plus text-secondary" style={{ fontSize: '1rem' }}></i>
                                            </div>
                                            <span className="fw-medium text-dark mb-1" style={{ fontSize: '1rem' }}>Add New Address</span>
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MyAddresses;